import { type FunctionComponent } from "react";

import iconImportMini from "images/Common/iconImportMini.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedImportMini: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={iconImportMini} style={baseProps.style} className={baseProps.className} />
    );
};
